import { ENVIRONMENT } from '../../../config/configuration';

const defaultProvider = 'symcor';

const byDisplayOrder = (a, b) => {
  const left = a.displayOrder ?? Number.MAX_SAFE_INTEGER;
  const right = b.displayOrder ?? Number.MAX_SAFE_INTEGER;
  return left - right;
};

const setDisplayOrderToIndex = (bank, index) => ({ ...bank, displayOrder: index + 1 });

const setOrShiftDisplayOrder = (startAt) => (bank, index) => {
  const displayOrder = index + startAt + 1;
  return {
    ...bank,
    displayOrder,
  };
};

const toLandingPage = (maxLandingPageSlots) => (bank, index) => ({
  ...bank,
  displayOnLanding: index < maxLandingPageSlots,
});

const mergeIntoMap = (map, providers, legacyProvider) => providers.reduce((updatedMap, providerList) => {
  providerList.reduce((acc, bank) => {
    if (bank.isDemo && ENVIRONMENT === 'prod') return acc;
    const bankKey = Object.keys(map).find((key) => map[key].providers?.[bank.provider]?.id === bank.id);
    if (bankKey) {
      const preferredProvider = map[bankKey].providers[defaultProvider] ? defaultProvider : legacyProvider;
      if (!acc[bankKey] || acc[bankKey].selectedProvider.provider !== preferredProvider) {
        acc[bankKey] = {
          name: bank.name,
          displayOrder: bank.displayOrder,
          selectedProvider: {
            provider: preferredProvider,
            id: map[bankKey].providers[preferredProvider].id,
            logo: bank.logo,
          },
        };
      }
    } else {
      // eslint-disable-next-line no-console
      console.error('Bank not found in mapper:', JSON.stringify(bank, null, 2));
    }
    return acc;
  }, updatedMap);
  return updatedMap;
}, {});

export default (maxLandingPageSlots, preferred, secondary, mapper, legacyProvider) => {
  const mergedMap = mergeIntoMap(mapper, [
    preferred.map(setDisplayOrderToIndex),
    secondary.sort(byDisplayOrder).map(setOrShiftDisplayOrder(preferred.length)),
  ], legacyProvider);
  const mergedProviders = Object.values(mergedMap).sort(byDisplayOrder);

  const ordered = mergedProviders.map(setDisplayOrderToIndex);
  const result = ordered.map(toLandingPage(maxLandingPageSlots));

  result.sort(byDisplayOrder);
  return result;
};
